import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

export const CategoryPageContext = createContext({
  title: null,
  page: 1,
});

export const useCategoryPage = () => useContext(CategoryPageContext);
const Provider = ({ children }) => {
  const [title, setTitle] = useState('Categoria');
  const [filter, setFilter] = useState(null);
  const [filterString, setFilterString] = useState(null);
  const handleTitle = useCallback((newTitle) => {
    setTitle(newTitle);
  }, [title]);

  const handleFilterString = useCallback((fString) => {
    setFilterString(fString);
  }, [filterString]);

  const handleFilter = useCallback((f, fString) => {
    setFilter(f);
    if (fString !== null && fString !== undefined) handleFilterString(fString);
  }, [filter]);

  const value = useMemo(() => {
    return {
      title,
      filter,
      filterString,
      setTitle: handleTitle,
      setFilter: handleFilter,
      setFilterString: handleFilterString,
    };
  }, [title, filter, filterString, handleTitle, handleFilter, handleFilterString]);

  return (
    <CategoryPageContext.Provider value={value}>
      { children }
    </CategoryPageContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
